import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69845926921dc90014acc87b/beautyskinclinic/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69845926921dc90014acc87b/beautyskinclinic/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69845926921dc90014acc87b/beautyskinclinic/src/app/appointments/components/AppointmentBooking.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69845926921dc90014acc87b/beautyskinclinic/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69845926921dc90014acc87b/beautyskinclinic/src/components/ui/AppIcon.tsx");
